<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="13" fill="none" viewBox="0 0 11 13">
        <path stroke="#2874E8" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M9.086 7.889l-.916.915-1.781 1.782c-1.356 1.318-3.395 1.294-4.689 0s-1.46-3.285 0-4.689l3.684-3.684C6.593 1.005 8.487.904 9.196 1.864c.387.526.942 1.723-.26 2.925L4.593 9.132c-.44.44-1.153.44-1.593 0-.44-.44-.44-1.152 0-1.592l3.253-3.253"/>
    </svg>
</template>

<script>
export default {
    name: 'attach-file-icon'
}
</script>
